const playSound = (sound, callback = () => {}) => {
    const snd = new Audio(sound);
    snd.play();
    snd.onended = callback
  };

  export default playSound